<div class="cv-dm-item__load-btn-group">
  @if (isStac()) {
    <button
      class="cv-dm-item__action-btn"
      type="button"
      [disabled]="disabled || actionsDisabled"
      (click)="onGetStacList($event)"
    >
      Get STAC List
    </button>
  } @else if (isTiles()) {
    <button
      class="cv-dm-item__action-btn"
      type="button"
      [disabled]="disabled || actionsDisabled"
      (click)="onLoadTiles($event)"
    >
      Load Tiles
    </button>
  } @else if (isFeatures()) {
    <button
      class="cv-dm-item__action-btn"
      type="button"
      [disabled]="disabled || actionsDisabled"
      (click)="onGetAll($event)"
    >
      Get All
    </button>
    <button
      class="cv-dm-item__action-btn"
      type="button"
      [disabled]="disabled || actionsDisabled"
      (click)="onBboxFilter($event)"
    >
      B-Box Filter
    </button>
    <button
      class="cv-dm-item__action-btn"
      type="button"
      [disabled]="disabled || actionsDisabled"
      (click)="onAttrFilter($event)"
    >
      Attribute Filter
    </button>
  }
</div>
